<template>
  <div id="files">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-button
              icon="fas fa-plus"
              type="primary"
              size="small"
              round
              v-if="true"
              @click="
                categoryId = null;
                addCategoryModal = true;
              "
            >
              {{ $t("contentManagement.files.addFolder") }}
            </el-button>
            <el-button icon="fas fa-plus" type="primary" size="small" :disabled="true" round v-else>
              {{ $t("contentManagement.files.addFolder") }}
            </el-button>
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <div class="card">
          <div class="card-header header-elements-inline" style="padding-bottom:0px;">
            <div class="card-title-container">
              <h5 class="card-title">{{ this.$t("event.menu.documents.title") }}</h5>
              <span v-if="getFileCount > 0 || categories.length > 0">
                <template v-if="$i18n.locale == 'tr'">Toplam {{ categories.length }} klasörde {{ getFileCount }} adet dosya bulunmaktadır.</template>
                <template v-else>There are {{ getFileCount }} files in a total of {{ categories.length }} folders.</template>
              </span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe('https://holacon.com/product-guide/')" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="getData" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <div v-if="false">
            <upgrade-overlay height="200px" key="upgrade-overlay"></upgrade-overlay>
          </div>
          <div v-else-if="getFileCount > 0 || categories.length > 0" key="content-overlay">
            <div class="card-body">
              <div class="folders-wrapper" :date="currDate">
                <draggable :list="categories" class="folders-item list-group-o" group="b" tag="div" handle=".el-icon-s-grid" v-bind="dragOptions" @start="drag = true" @end="saveSorting">
                  <div class="folders-container" v-for="(item, index) in categories" :key="item.id">
                    <div class="folders-header" :class="item.isActive ? '' : 'passive'">
                      <span>
                        <i :style="'color:' + item.color" class="fas fa-folder-open" v-if="loading != 'deleteDocument-' + item.id"></i>
                        <i v-else class="el-icon-loading"></i>
                        {{ item.title }}
                      </span>

                      <div class="folder-controls" :class="item.isActive ? '' : 'passive'">
                        <span
                          @click="
                            categoryId = item.id;
                            addCategoryModal = true;
                          "
                        >
                          <i class="fa fa-pen"></i>
                        </span>
                        <span>
                          <i :class="loading == item.id ? 'el-icon-loading' : 'el-icon-s-grid'"></i>
                        </span>
                      </div>
                    </div>

                    <draggable :list="categories[index].files" class="folders-inner-items list-group-o" group="a" tag="div" handle=".el-icon-s-grid" v-bind="dragOptions" @start="drag = true" @end="saveSorting">
                      <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                        <div class="folders-inner-item" v-for="element in item.files" :key="element.id" :class="element.isActive ? '' : 'passive'">
                          <i :class="loading == item.id || loading == 'deleteFile-' + element.id ? 'el-icon-loading' : 'el-icon-s-grid'"></i>
                          <div class="folder-item-inner-title">
                            <img fit="contain" :src="'/static/icons/' + getExtension(element.image) + '.svg'" />
                            <div class="text-container">
                              <span>
                                {{ element.title }}
                                <b>{{ "." + getExtension(element.image) }}</b>
                              </span>
                              <span v-if="element.fileSizeInMb != null">{{ element.fileSizeInMb.toFixed(2) }} mb</span>
                            </div>
                          </div>
                          <div class="folder-item-inner-actions">
                            <el-popover placement="top-start" width="200" trigger="click">
                              <template>
                                <div class="action-item" @click="download(element)">
                                  <span>{{ $t("contentManagement.files.downloadDocument") }}</span>
                                  <i class="fas fa-download"></i>
                                </div>
                                <div
                                  class="action-item"
                                  @click="
                                    currentCategory = item.id;
                                    addModal = true;
                                    updateForm = element.id;
                                  "
                                >
                                  <span>{{ $t("contentManagement.files.editDocument") }}</span>
                                  <i class="fas fa-pen"></i>
                                </div>
                                <el-popconfirm @confirm="deleteItem(element)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                                  <div class="action-item" slot="reference">
                                    <span>{{ $t("contentManagement.files.deleteDocument") }}</span>
                                    <i class="fas fa-trash"></i>
                                  </div>
                                </el-popconfirm>
                              </template>
                              <i aria-hidden="true" slot="reference" class="action-icon fa fa-ellipsis-v"></i>
                            </el-popover>
                          </div>
                        </div>
                      </transition-group>
                    </draggable>

                    <div class="folders-footer">
                      <el-button
                        round
                        size="small"
                        type="primary"
                        @click="
                          updateForm = null;
                          currentCategory = item.id;
                          addModal = true;
                        "
                      >
                        <i class="fas fa-plus"></i>
                        {{ $t("contentManagement.files.addDocument") }}
                      </el-button>
                    </div>
                  </div>
                </draggable>
              </div>
            </div>
          </div>
          <div v-else>
            <HolaconLottieNoData
              class="w-100"
              key="create-loading"
              :source="'holacon-document-lottie'"
              :title="$t('event.menu.documents.title')"
              @btnAdd="
                categoryId = null;
                addCategoryModal = true;
              "
              @btnRefresh="getData()"
              :buttonAdd="true"
              :buttonRefresh="true"
              :loading="loading"
            />
          </div>
          <div class="card-footer"></div>
        </div>
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="addModal" :title="updateForm ? $t('contentManagement.files.editDocument') : $t('contentManagement.files.addDocument')" class="medium" center modal-append-to-body destroy-on-close>
      <FileAddUpdate @deleteMe="deleteItem" @closeDialog="addModal = false" :id="updateForm" :categoryId="currentCategory" v-if="addModal" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="addCategoryModal" :title="categoryId ? $t('contentManagement.files.editFolder') : $t('contentManagement.files.addFolder')" class="medium" center modal-append-to-body destroy-on-close>
      <FileCategoryAddUpdate @deleteMeCategory="deleteItemCategory" @closeDialog="addCategoryModal = false" v-if="addCategoryModal" :id="categoryId" />
    </el-dialog>
  </div>
</template>

<script>
import { saveAs } from "file-saver";
import FileCategoryAddUpdate from "../../components/FileCategoryAddUpdate";
import FileAddUpdate from "../../components/FileAddUpdate";
import ExcelImport from "../../components/ExcelImport";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import draggable from "vuedraggable";
import _ from "lodash";
export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.documentsAndFiles")
    };
  },
  components: {
    FileAddUpdate,
    ExcelImport,
    PageCountInfo,
    draggable,
    FileCategoryAddUpdate
  },
  name: "Files",
  data() {
    return {
      loading: false,
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "areamaps",
      drag: false,
      currentCategory: null,
      axios,
      addModal: false,
      addCategoryModal: false,
      categoryId: null,
      currDate: new Date().getTime()
    };
  },
  methods: {
    download(item) {
      window.open(item.image, "_blank");
      // fetch(item.image)
      //   .then((response) => response.blob)
      //   .then((blob) => {
      //     const link = document.createElement('a');
      //     link.href = URL.createObjectURL(blob);
      //     link.download = item.title;
      //     link.click();
      //   });
      // saveAs(file, item.title + '.' + this.getExtension(item.image));
    },
    getExtension(url) {
      if (url == null) return "";
      return url.split(".")[url.split(".").length - 1];
    },
    async deleteItem(item) {
      this.loading = "deleteFile-" + item.id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("documentFileDelete", item.id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getDocumentCategoryList");
        }
        this.loading = false;
      }, 500);
    },
    async deleteItemCategory(id) {
      this.loading = "deleteDocument-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("documentDelete", id);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getDocumentCategoryList");
        }
        this.loading = false;
      }, 500);
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleAreaMap", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedAreaMaps", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },
    async saveSorting() {
      this.loading = "loadingList";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("updateDocumentSorting", this.categories);
        this.loading = false;
      }, "500");
    },
    async getData() {
      this.loading = "loadingList";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getDocumentCategoryList");
        this.loading = false;
      }, "500");
    }
  },
  async created() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.getData();
      this.loading = false;
    }, 500);
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    categories() {
      return this.$store.state.files.items;
    },
    getFileCount() {
      var i = 0;
      this.categories.map(k => {
        i = i + k.files.length;
      });

      return i;
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    skip() {
      return (this.$store.state.sponsors.filter.page - 1) * this.$store.state.sponsors.filter.take;
    },
    take() {
      return this.skip + this.$store.state.sponsors.items.length;
    }
  },
  watch: {
    "$store.state.sponsors.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getAreaMaps");
      }, 500);
    }
  }
};
</script>

<style lang="less">
.list-group-o {
  & > span {
    min-height: 260px;
  }
}
.folders-wrapper {
  padding: 16px 0px;

  .folders-item {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    min-height: 350px;
    grid-gap: 10px;

    .folders-container {
      background-color: #fbfbfb;
      border: 0.5px solid #f1f3f6;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      border-radius: 8px;
      position: relative;

      .folders-header {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background: #f1f1f1;
        padding: 10px 14px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;

        &.passive {
          background-color: #fff2f2;
        }

        span {
          font-size: 14px;
          color: #292f3b;
          font-weight: 600;
          line-height: normal;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 220px;

          i {
            font-size: 20px;
          }

          &:first-child {
            i {
              margin-right: 6px;
            }
          }

          &:last-child {
            i {
              font-size: 16px;
              cursor: pointer;
            }
          }
        }

        .folder-controls {
          display: flex;
          justify-content: center;
          align-items: center;

          span {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 32px;
            height: 32px;
            margin-left: 4px;

            i {
              box-sizing: border-box;
              font-size: 20px;
              color: #505763;
              padding: 2px 0px;
              cursor: grab;
            }
          }

          &.passive {
            background-color: #fff2f2;
          }
        }
      }

      .folders-inner-items {
        width: 100%;
        min-height: 260px;
        // max-height: 280px;
        // overflow-y:auto;
        padding: 0px 8px;
        position: relative;
        height: 100%;

        & > span {
          min-height: 260px;
          height: 100%;
          display: block;
        }

        .folders-inner-item {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          background: #f1f1f1;
          padding: 8px 10px;
          margin: 8px 0px;
          border-radius: 8px;

          &:last-child {
            margin-bottom: 0px;
          }

          &.passive {
            background-color: #fff2f2;
          }

          i {
            box-sizing: border-box;
            font-size: 20px;
            color: #505763;
            cursor: grab;
            margin-right: 8px;
          }

          .folder-item-inner-title {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-content: center;
            width: 100%;

            img {
              width: 26px;
              margin-right: 8px;
              margin-left: 2px;
              border-radius: 8px;
              padding: 3px;
            }

            .text-container {
              span {
                font-size: 13px;
                color: #505763;
                font-weight: 500;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 160px;
                display: block;

                b {
                  font-size: 13px;
                  color: #292f3b;
                  font-weight: 600;
                }
              }
            }
          }

          .folder-item-inner-actions {
            background: transparent;
            .action-icon {
              background: transparent;
              display: flex;
              align-items: center;
              margin-left: 12px;
              margin-right: 0px;
              color: #8c929c;
              font-size: 12px;
              padding: 6px 0px;
              cursor: pointer;
            }
          }
        }
      }

      .folders-footer {
        padding: 6px 0px 6px;
      }
    }
  }
}

.action-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 6px 4px;
  cursor: pointer;

  span {
    font-size: 13px;
    color: #505763;
    font-weight: 500;
  }
  i {
    color: #292f3b;
  }

  &:last-child {
    span,
    i {
      color: #ff6565;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/event/Files.vue